import './Chart_analysis.scss';
import React, { useState, useEffect } from "react";
import HeaderTitle from "../comm/HeaderTitle";
import fnc from "../mymod/commFunction";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label, } from "recharts";
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import { useDispatch, useSelector } from "react-redux";
import {  setHeaderInfo, setHeader_dev, setSelectedTesNm,} from "../reduxToolkit/redux";


const Chart_analysis = ({ selectedListItem, setIsModal }) => {
 
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [dataList, setDataList] = useState([]);
  const [dataListAvg, setDataListAvg] = useState([]);

  const lmsListCode = useSelector(state => state.reduxStore.lmsListCode);


  useEffect(() => {
    fncSelect_analysis_testGroup();
  }, []);

  useEffect(() => {
    if (dataListAvg.length > 0) {
      fncSelect_analysis_st();
    }
  }, [dataListAvg]);
  


  const fncSelect_analysis_testGroup = () => {
    const acaCode = fnc.getCookie('acaCode');

    fnc.sendAxios("/kuesbChartRoutes/select/alalysis_testGroup", {  acaCode, parentCode: lmsListCode  }, (res) => {
      if (Array.isArray(res) ) {
        setDataListAvg(res);
      } else {
        console.log(res, "/kuesbChartRoutes/select/alalysis_testGroup");
      }
    });
  };
  
  const fncSelect_analysis_st = () => {
    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');

    fnc.sendAxios("/kuesbChartRoutes/select/alalysis_st", {  acaCode, stCode, parentCode: lmsListCode  }, (res) => {
      if (res) {
        if(dataListAvg.length > 0) {
          const data = fncGet_analysisData_st(res);
          setDataList(data);
        }
      } else {
        console.log(res, "/kuesbChartRoutes/select/alalysis_st");
      }
    });
  };

  
  function fncGet_analysisData_st(res) {//O의 개수가 0인 경우도 포함
    // 시각화에 사용할 데이터 변환
    const simplifiedData = res.map(({ item, avg }) => {
      // dataListAvg에서 해당 item의 평균(avg)을 찾음
      const avgData = dataListAvg.find(avgItem => avgItem.item === item);
      return {
        name: item,
        점수: avg.toFixed(1),
        평균: avgData ? avgData.avg.toFixed(1) : 0 // 평균이 없으면 기본값 0
      };
    });
  
    return simplifiedData;
  }
  


  //===================================================================================

  const fncSelect_analysis = () => {//이 방식 사용 안 함 sql에서 평균 처리 일단 지우지 말자
    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');

    fnc.sendAxios("/kuesbChartRoutes/select/alalysis", {  acaCode, stCode, parentCode: lmsListCode  }, (res) => {
      if (res) {
        if(dataListAvg.length > 0) { 
          const data = fncGet_analysisData(res);
          setDataList(data);
        }
      } else {
        console.log(res, "/kuesbChartRoutes/select/alalysis");
      }
    });
  };


  function fncGet_analysisData(res) {//O의 개수가 0인 경우도 포함
    // 전체 item 개수 계산
    const itemCounts = res.reduce((acc, entry) => {
      acc[entry.item] = (acc[entry.item] || 0) + 1; // item별 전체 개수 계산
      return acc;
    }, {});
  
    // 맞은 개수 계산
    const correctCounts = res.reduce((acc, entry) => {
      if (entry.OX === "O") {
        acc[entry.item] = (acc[entry.item] || 0) + 1; // item별 정답 개수 누적
      }
      return acc;
    }, {});
  
    // 모든 item을 포함하는 초기 데이터 생성
    const allItems = [...new Set(res.map(entry => entry.item))]; // 모든 고유 item 추출
    const scoresByItemValue = allItems.map(item => ({
      item,
      totalScore: 0,
      correctCount: correctCounts[item] || 0, // O의 개수가 없으면 0
      totalItemCount: itemCounts[item] || 0, // 전체 개수
    }));
  
    // 점수와 백분율 계산
    scoresByItemValue.forEach(entry => {
      entry.percentageByItem = entry.totalItemCount > 0
        ? ((entry.correctCount / entry.totalItemCount) * 100).toFixed(1) // 백분율 계산
        : 0; // 항목 데이터가 없는 경우 0
    });
  
    // 결과 정렬 (item 기준)
    scoresByItemValue.sort((a, b) => a.item.localeCompare(b.item));
  
    // 시각화에 사용할 데이터 변환
    const simplifiedData = scoresByItemValue.map(({ item, percentageByItem }) => {
      // dataListAvg에서 해당 item의 평균(avg)을 찾음
      const avgData = dataListAvg.find(avgItem => avgItem.item === item);
      return {
        name: item,
        점수: percentageByItem,
        평균: avgData ? avgData.avg.toFixed(1) : 0 // 평균이 없으면 기본값 0
      };
    });
  
    return simplifiedData;
  }
  
 

  //==================================================================================
  return (
    <div className="Chart_analysis">

    {true > 0 && <div className="box-chart">

     <div style={{ width: "50rem", height: 400, marginTop: '3rem' }}>
       <h1 className='chartTitle'>영역별 점수</h1>
       
        <ResponsiveContainer width="100%" height="100%">
        <BarChart
          // width={200}
          // height={300}
          data={dataList}
          margin={{top: 7, right: 30, left: 10, bottom: 5, }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis domain={[0, 100]} /> {/* Y축 최대값 설정 */}
          <Tooltip />
          <Legend />
          <Bar dataKey="점수" fill="#8884d8" label={{ position: "top" }} activeBar={<Rectangle fill="pink" stroke="blue" />} />
          <Bar dataKey="평균" fill="#82ca9d" label={{ position: "top" }} activeBar={<Rectangle fill="gold" stroke="purple" />} />
        </BarChart>
      </ResponsiveContainer>


      </div> 

      </div>}
    </div>
  );
};

export default Chart_analysis;
